import React, { useEffect } from "react";
import { RouteComponentProps, navigate } from "@reach/router";
import { Grid } from "@material-ui/core";
import { useSnackbar } from "components/haven-design/snackbar";
import { LoadingSpinner } from "components/graphql-views";
import Viewer from "components/viewer/context";
import { UserRole } from "types/gql-types";

const EmailVerified: React.FC<RouteComponentProps> = () => {
  const { openSnackbar } = useSnackbar();
  const viewer = React.useContext(Viewer);

  useEffect(() => {
    openSnackbar({ message: "Your email address is now verified.", status: "success", duration: 3000 });
    if (viewer && viewer.logins?.length) {
      const { logins: [{ roles }] } = viewer;
      if (roles) {
        if (roles.includes(UserRole.CLIENT)) {
          navigate("/properties");
        } else if (roles.includes(UserRole.PROPERTY_MANAGER) ||
        roles.includes(UserRole.SUPERVISOR)) {
          navigate("/dash/manager/lists");
        } else if (roles.includes(UserRole.ADMIN)) {
          navigate("/dash/admin");
        }
      } else {
        navigate("/login");
      }
    } else {
      navigate("/login");
    }
  }, []);
  return (
    <Grid container justifyContent="center" spacing={2} direction="row">
      <LoadingSpinner />
    </Grid>
  );
};

export default EmailVerified;
